import { render, staticRenderFns } from "./invoice-payment-cancel-page.vue?vue&type=template&id=9153bff4&scoped=true&"
import script from "./invoice-payment-cancel-page.vue?vue&type=script&lang=ts&"
export * from "./invoice-payment-cancel-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9153bff4",
  null
  
)

export default component.exports